import { ReactElement } from 'react';

import { useTranslation } from 'modules/i18n';
import { CosmostationWalletIcon } from 'modules/icons';

import { WalletId } from '../../const';
import { ConnectButton } from '../ConnectButton';
import { translation } from './translation';

const INSTALL_WALLET_LINK =
  'https://chromewebstore.google.com/detail/cosmostation/fpkhgmpbidmiogeglndfbkegfdlnajnf';

export function CosmostationWalletConnectButton(): ReactElement {
  const { t, keys } = useTranslation(translation);
  return (
    <ConnectButton
      icon={<CosmostationWalletIcon height={36} width={36} />}
      installWalletLink={INSTALL_WALLET_LINK}
      name={t(keys.cosmostationWallet)}
      walletId={WalletId.cosmostation}
    />
  );
}
